import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
// import CheckBox from '~/componentes/CustomForm/Check/styles/CheckBox';

import { Container } from './styles';
// import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
// import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
// import Acoordion from '~/componentes/Acoordion';
// import Button from '~/componentes/Button';
// import IconLixeira from '~/assets/icones/IconLixeira.svg';
import AtividadesList from './AtividadesList';

function CreateContent() {
  // const [clientes, setClientes] = useState([]);
  // const [projetos, setProjetos] = useState([]);
  // const [horarios, setHorarios] = useState([]);
  const [ordemServicos, setOrdemServicos] = useState([]);
  const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);
  const [dataEmissaoD, setDataEmissaoD] = useState(new Date().toISOString().split('T')[0]);
  const [dataEmissaoA, setDataEmissaoA] = useState(new Date().toISOString().split('T')[0]);
  const [statusAprovacao, setStatusAprovacao] = useState('A');
  const [analistas, setAnalistas] = useState([]);
  const [idAnalistaFiltro, setIdAnalistaFiltro] = useState('');

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/gerencia/analistas')
      .then(response => setAnalistas(response.data));
  }, []);

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/aprovarordemservico2/oss', {
        params: {
          dataEmissao: dataEmissaoD,
          dataEmissaoA,
          statusAprovacao,
          ...(idAnalistaFiltro ? { idAnalista: idAnalistaFiltro } : {}),
        },
      })
      .then(response => setOrdemServicos(response.data));
  }, [dataEmissaoD, dataEmissaoA, statusAprovacao, idAnalistaFiltro]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let listaOS = [];
        for (const item of ordemServicoAtividades) {
          listaOS.push({
            statusAprovacao,
            idOrdemServico: item?.id,
            aprovar: item?.aprovar,
            observacao: item?.observacao,
          });
        }

        let thisData = { ordemServicos: listaOS };

        let response = await api.put(
          '/signed/empresa/gestorprojeto/aprovarordemservico2',
          thisData,
        );
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao aprovar/reprovar essas Ordens de Serviços, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja aprovar/reprovar essas Ordens de Serviços?`,
        successModal: `Ordens de Serviços aprovadas/reprovadas com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        <div className="row">
          <div className="col s12 m12 l12">
            <div className="row">
              <Label title="Data De *" className="col s6 m6 l2">
                <Input
                  type="date"
                  name="dataEmissao"
                  required="true"
                  defaultValue={dataEmissaoD}
                  onChange={e => {
                    setDataEmissaoD(e.currentTarget.value);
                  }}
                />
              </Label>
              <Label title="Data Até*" className="col s6 m6 l2">
                <Input
                  type="date"
                  name="dataEmissao"
                  required="true"
                  defaultValue={dataEmissaoA}
                  onChange={e => {
                    setDataEmissaoA(e.currentTarget.value);
                  }}
                />
              </Label>
              <Label title="Analista" className="col s6 m6 l3">
                <Select
                  isNumber
                  list={{
                    list: analistas,
                    value: 'id',
                    label: 'nome',
                  }}
                  name="idAnalista"
                  defaultValue={idAnalistaFiltro}
                  firstOption
                  onChange={e => {
                    const v = e.currentTarget.value || '';
                    setIdAnalistaFiltro(v);
                  }}
                />
              </Label>
              <Label title="Aprovador *" className="col s6 m6 l3">
                <Select
                  required="true"
                  isString
                  list={{
                    list: [
                      { id: 'A', titulo: 'Aguard. Aprovador 1' },
                      { id: 'C', titulo: 'Aguard. Aprovador 2' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="statusAprovacao"
                  defaultValue={'T'}
                  onChange={e => {
                    const v = e.currentTarget.value || 'T';
                    setStatusAprovacao(v);
                  }}
                />
              </Label>
            </div>
            <div className="row">
              <div className="col s12 m12 l12">
                <AtividadesList
                  setter={setOrdemServicoAtividades}
                  defaultData={ordemServicos || []}
                />
              </div>
            </div>
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
